export default "__VITE_ASSET__c6153a51__"